<template>
    <div>
      <div class="spinner-container" v-if="loading">
        <blade-spinner nested background-color="rgba(0,0,0,0)" spinner-color="#212529" />
      </div>
      <div class="dropin-container">
        <div ref="dropinTarget"/>
      </div>
    </div>
</template>

<script>
import BraintreeDropin from 'braintree-web-drop-in';
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      dropin: null,
      loading: false
    };
  },

  mounted() {
    this.initDropin();
  },

  beforeDestroy() {
    if (this.dropin) {
      this.dropin.teardown();
    }
  },

  methods: {
    ...mapActions([
      'generateClientToken'
    ]),

    async initDropin() {
      if (this.dropin) return;
      try {
        this.loading = true;

        for (let i = 0; i < 20; ++i) {
          if (this.$refs.dropinTarget) break;
          await this.$nextTick();
        }

        if (!this.$refs.dropinTarget) {
          // TODO: Braeden, do better error handling.
          const err = { error: 'Failed to initialize payment processing interface, please try again later.' };
          throw err;
        }

        const clientToken = await this.generateClientToken();

        // TODO: Braeden, do better error handling.
        if (!clientToken) return this.$router.showGameErrorCritical();

        BraintreeDropin.create({
          vaultManager: false,
          authorization: clientToken,
          container: this.$refs.dropinTarget,
          card: {
            cardholderName: {
              required: true
            },
            overrides: {}
          },
          paypal: {
            flow: 'vault'
          },
          /*
          venmo: {},
          googlePay: {
            googlePayVersion: 2,
            // TODO: This for production...?
            merchantId: null,
            transactionInfo: {
              totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
              currencyCode: 'USD'
            }
          },
          */

        }, (error, dropin) => {
          if (error) {
            // TODO: Braeden, do better error handling.
            // eslint-disable-next-line no-alert
            console.error(error);
            return;
          }

          this.$set(this, 'dropin', dropin);
          this.$emit('loaded', dropin);
          if (dropin) {
            dropin.on('paymentMethodRequestable', (payload) => {
              this.$emit('payment-method-changed', payload.paymentMethodIsSelected);
            });

            // eslint-disable-next-line no-unused-vars
            dropin.on('paymentOptionSelected', (payload) => {
              this.$emit('payment-method-changed', true);
            });
          }
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropin-container
{
  max-width: 80vw;
}

.spinner-container
{
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/braintree/DropinContainer.vue